var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorHubActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5711_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5003 11.8214C14.5003 13.6889 13.1203 15.0839 11.2603 15.0914C9.3928 15.0989 7.9753 13.6964 7.9678 11.8439C7.9603 9.98394 9.3628 8.57394 11.2303 8.56644C13.1128 8.55894 14.5003 9.93894 14.5003 11.8214Z",
    fill: "#744FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.25 11.7644C0.25 11.0069 0.25 10.2419 0.25 9.48438C0.25 9.07937 0.415 8.92188 0.8125 8.92188C2.335 8.92188 3.85 8.92188 5.3725 8.92188C5.77 8.92188 5.95 9.10938 5.95 9.51438C5.95 11.0219 5.95 12.5219 5.95 14.0294C5.95 14.4494 5.77 14.6294 5.3575 14.6294C3.8425 14.6294 2.335 14.6294 0.82 14.6294C0.4075 14.6219 0.25 14.4644 0.25 14.0444C0.25 13.2869 0.25 12.5219 0.25 11.7644Z",
    fill: "#744FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00694 6.71565C5.94944 6.71565 4.89944 6.71565 3.84194 6.71565C3.51194 6.71565 3.31694 6.61065 3.28694 6.36315C3.27944 6.21315 3.32444 6.03315 3.40694 5.89815C4.39694 4.29315 5.39444 2.68815 6.39194 1.08315C6.44444 1.00065 6.49694 0.918148 6.54944 0.835648C6.83444 0.385648 7.20944 0.385648 7.49444 0.850648C8.01944 1.69815 8.55194 2.55315 9.07694 3.40065C9.59444 4.23315 10.1044 5.06565 10.6294 5.89065C10.7494 6.08565 10.8169 6.27315 10.7044 6.48315C10.5919 6.69315 10.3894 6.72315 10.1794 6.72315C9.12194 6.71565 8.06444 6.71565 7.00694 6.71565Z",
    fill: "#744FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5711_4703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.25,
    height: 14.595,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorHubActive);
export default __webpack_public_path__ + "static/media/tutorHubActive.c8bd4fbb9f7ddc29f8be2839d471493e.svg";
export { ForwardRef as ReactComponent };